import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=c215189a&scoped=true&"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js&"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=c215189a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c215189a",
  null
  
)

export default component.exports